<section class="w-full h-full bg-[#FAFAFA] md:px-10 md:py-16 px-4 py-8">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col justify-evenly gap-14 md:gap-0 items-center h-full w-full">
      <div class="flex flex-col lg:flex-row justify-between items-center gap-4 w-full md:mt-14">
        <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8 md:mb-0 mb-5">
          <div class="w-full h-full">
            <img
              src="lite/flow_event/flow_event1.png"
              alt="Lite Flow Event 1"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="flex items-center justify-center gap-2">
            <p
              i18n="lite.flow.event|Create Event or Tournament step@@lite.flow.event.step1"
              class="text-black md:text-base text-smfont-medium"
            >
              Create Event or Tournament
            </p>
          </div>
        </div>

        <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8 md:mb-0 mb-5">
          <div class="w-full h-full">
            <img
              src="lite/flow_event/flow_event2.png"
              alt="Lite Flow Event 2"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="flex items-center justify-center gap-2">
            <p
              i18n="lite.flow.event|Invite Player step@@lite.flow.event.step2"
              class="text-black md:text-base text-sm font-medium"
            >
              Invite Player
            </p>
          </div>
        </div>

        <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8">
          <div class="w-full h-full">
            <img
              src="lite/flow_event/flow_event3.png"
              alt="Lite Flow Event 3"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="flex items-center justify-center gap-2">
            <p
              i18n="lite.flow.event|Player Joining step@@lite.flow.event.step3"
              class="text-black md:text-base text-sm font-medium"
            >
              Player Joining
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
